import { Component } from '@nicolas-riciotti/light2'

export default class CoreModal extends Component {

  constructor() {
    super()

    // Elements.
    this.$previousTrigger = null
    this.$triggers = null
    this.$first_item = null
    this.$last_item = null

    // State.
    this.isTrapped = false
    this.isExpanded = false
    this.hasOverlay = false
  }

  created() {
    this.transitionFinishedBound = this.transitionFinished.bind(this)
    this.toggleModalBound = this.toggleModal.bind(this)
    this.globalKeydownBound = this.globalKeydown.bind(this)
    this.globalPointerDownBound = this.globalPointerDown.bind(this)
  }

  attached() {
    this.hasOverlay = 'true' === this.dataset.hasOverlay

    // After transitioning the modal, handle focus.
    this.addEventListener('transitionend', this.transitionFinishedBound, false)

    // Handle multiple triggering elements.
    this.$triggers = document.querySelectorAll(`[aria-controls="${this.id}"]`)
    this.$triggers.forEach($el => {
      $el.addEventListener('click', this.toggleModalBound, false)
    })
  }

  detached() {
    this.removeEventListener('transitionend', this.transitionFinishedBound)

    this.$triggers.forEach($el => {
      $el.removeEventListener('click', this.toggleModalBound)
    })

    if (this.isExpanded) {
      this.removeGlobalListener()
    }
  }

  attachGlobalListener() {
    document.addEventListener('keydown', this.globalKeydownBound, false)
    document.addEventListener('pointerdown', this.globalPointerDownBound, false)
  }

  removeGlobalListener() {
    document.removeEventListener('keydown', this.globalKeydownBound)
    document.removeEventListener('pointerdown', this.globalPointerDownBound)
  }

  globalKeydown(event) {
    // Close the modal with the escape key.
    if (event.key === 'Escape' || event.key === 'Esc') {
      this.closeModal()
    }

    // Focus management (trap keyboard tabbing).
    if (!(event.key === 'Tab' || event.keyCode === 9) || !this.isTrapped) {
      return
    }

    // Refresh focusable items (kludge).
    this.getFocusableItems()

    if (event.shiftKey) {
      if (document.activeElement === this.$first_item && this.$last_item) {
        this.$last_item.focus()
        event.preventDefault()
      }
    } else {
      if (document.activeElement === this.$last_item && this.$first_item) {
        this.$first_item.focus()
        event.preventDefault()
      }
    }
  }

  globalPointerDown(event) {
    let skip = false
    for (let i = 0; i < this.$triggers.length; i++) {
      if (event.target === this.$triggers[i]) {
        skip = true
        break
      }
    }

    // Close the modal if the clicked target is anything other than the known
    // components.
    if (!skip && !this.contains(event.target) && event.target !== this) {
      this.closeModal()
    }
  }

  transitionFinished(event) {
    if (event.target !== this || event.propertyName !== 'transform') {
      return
    }

    // Move focus to modal.
    if (this.isExpanded) {
      if (this.dataset.focusElement) {
        document.getElementById(this.dataset.focusElement).focus()
      } else {
        this.focus()
      }
    // Restore focus to original triggering element.
    } else if (this.$previousTrigger) {
      this.$previousTrigger.focus()
      this.$previousTrigger = null
    }
  }

  toggleModal(event) {
    this.isExpanded ? this.closeModal() : this.openModal()
  }

  openModal() {
    console.log('openModal')
    this.isExpanded = true
    this.trap()
    this.showModal('true')
    this.attachGlobalListener()
  }

  closeModal() {
    this.isExpanded = false
    this.showModal('false')
    this.untrap()
    this.removeGlobalListener()

    setTimeout(()=>{
      document.querySelector(`[aria-controls="${this.id}"]`)?.focus();
      console.log('FOCUS SETTINGS BUTTON');
    }, 100);
  }

  showModal(flag) {
    this.$triggers.forEach($el => {
      $el.ariaExpanded = flag
    })
    this.setAttribute('data-open', flag)
    if (this.hasOverlay) {
      document.body.classList[ 'true' === flag ? 'add' : 'remove' ]('has-overlay')
    }
  }

  trap() {
    this.isTrapped = true

    // Save the original triggering element to be re-focused.
    this.$previousTrigger = (document.activeElement || document.body)
    this.$previousTrigger.blur()

    this.getFocusableItems()


    setTimeout(()=>{
      this.$first_item.focus();
    }, 100)

  }

  untrap() {
    this.isTrapped = false
    this.$first_item = null
    this.$last_item = null
  }

  getFocusableItems() {
    // Get focus-able items.
    const input_types = [
      'button', 'checkbox', 'date', 'email', 'file', 'number', 'password',
      'radio', 'range', 'search', 'submit', 'tel', 'text',
    ]
    const inputs = input_types
      .map(type => `input[type="${type}"]:not([disabled])`).join(', ')
    const selector = `a[href],
      button:not([disabled]), textarea:not([disabled]), ${inputs},
      select:not([disabled]), iframe, [tabindex]:not([tabindex="-1"]`
    const focusable = this.querySelectorAll(selector)
    const visible = Array.from(focusable).filter(child => null === child.closest('.hidden'))
    this.$first_item = visible[0]


    this.$last_item = visible[visible.length - 1]
  }

}

customElements.define('core-modal', CoreModal)
